/**
 * This is only exported to be covered by tests
 */
export const getQueryParamsFromHref = (href) => {
    const [url, params] = href.split('?');
    return [url, new URLSearchParams(params)];
};
